import { z } from 'zod';
import { actorRefSchema, roleRefSchema } from '#src/access/roles.contract.js';
export const PERMISSION_TITLE_MAX_LENGTH = 100;
export const PERMISSION_DESCRIPTION_MAX_LENGTH = 500;
/**
 * Uma permissão como a tela a mostra: o texto em vigor (o do administrador,
 * se houver, ou o do código) e o padrão, para restaurar.
 */
export const permissionEntrySchema = z.strictObject({
    key: z.string(),
    /** Nome do recurso, para agrupar (`Usuários`). */
    resource: z.string(),
    title: z.string(),
    description: z.string(),
    defaultTitle: z.string(),
    defaultDescription: z.string(),
    /** O administrador reescreveu o título ou a descrição. */
    customized: z.boolean(),
    /** Quem mudou o texto por último, e quando; nulos sem mudança. */
    customizedBy: actorRefSchema,
    customizedAt: z.iso.datetime({ offset: true }).nullable(),
    /** O que ela exige, direto (as exigidas podem exigir outras). */
    requires: z.array(z.string()),
    /** Perfis que a concedem. */
    roles: z.array(roleRefSchema),
});
/** O catálogo é pequeno e fixo: vai inteiro, na ordem do código. */
export const permissionListSchema = z.strictObject({
    items: z.array(permissionEntrySchema),
});
/**
 * Reescreve o texto de uma permissão. `null` volta ao do código. A chave e o
 * que ela libera não mudam: são do código.
 */
export const updatePermissionRequestSchema = z.strictObject({
    title: z.string().trim().min(1).max(PERMISSION_TITLE_MAX_LENGTH).nullable(),
    description: z
        .string()
        .trim()
        .min(1)
        .max(PERMISSION_DESCRIPTION_MAX_LENGTH)
        .nullable(),
});
//# sourceMappingURL=permission-entries.contract.js.map